(function () {
  const ROOT_ID = "toast-root";

  function ensureRoot() {
    let root = document.getElementById(ROOT_ID);
    if (!root) {
      root = document.createElement("div");
      root.id = ROOT_ID;
      root.className = "toast-root";
      root.setAttribute("aria-live", "polite");
      root.setAttribute("aria-atomic", "true");
      document.body.appendChild(root);
    }
    return root;
  }

  function showToast(message, options = {}) {
    const { duration = 3000 } = options;

    const root = ensureRoot();

    const toast = document.createElement("div");
    toast.className = "toast";
    toast.setAttribute("role", "status");

    // Small dot + message (clean look)
    const dot = document.createElement("span");
    dot.className = "toast__dot";

    const text = document.createElement("div");
    text.className = "toast__text";
    text.textContent = message;

    toast.appendChild(dot);
    toast.appendChild(text);

    // Click to dismiss
    toast.addEventListener("click", () => dismiss());

    root.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
      toast.classList.add("is-visible");
    });

    let dismissed = false;

    function dismiss() {
      if (dismissed) return;
      dismissed = true;

      toast.classList.remove("is-visible");
      toast.classList.add("is-hiding");

      // Allow transition to finish
      window.setTimeout(() => {
        toast.remove();
      }, 220);
    }

    // Auto dismiss
    window.setTimeout(dismiss, duration);

    return { dismiss };
  }

  // Expose globally
  window.StockupToast = { showToast };
})();
